import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractSecurityStorage, OidcSecurityService } from "angular-auth-oidc-client";
import { AppJwtHelperService } from './jwt-helper-service';
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { OidcLoginContextService } from "@core/auth/oidc-login-context.service";


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  urlApi: string = environment.host;
  private token: string = "";
  time!: number;

  valor = 1705469700;
  readonly TOKEN_KEY: string = "token";

  constructor(
    private router: Router,
    private appJwtHelper: AppJwtHelperService,
    private storageService: AbstractSecurityStorage,
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService,
    private oidcLoginContext: OidcLoginContextService
  ) {
    if (!environment.production) {
      this.loadToken();
    }
  }

  getToken(): string {
    return this.token;
  }

  getInfoToken(): {
    iss?: string;
    sub?: string;
    aud?: string[] | string;
    exp?: number;
    nbf?: number;
    iat?: number;
    jti?: string;
    groups?: string[];
  } {
    if (this.token) {
      return this.appJwtHelper.decodeToken(this.token);
    }
    return {};
  }


  setToken(token: string): void {
    this.token = token;
    if (environment.production === false) {
      this.storageService.write(this.TOKEN_KEY, token);
    }
  }


  async refreshToken(url: string): Promise<void> {
    const configId = this.oidcLoginContext.getPendingConfigId();
    this.oidcSecurityService.getRefreshToken(configId).subscribe((refreshToken) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${this.token}`,
      };
      const body = `grant_type=refresh_token&client_id=${this.getInfoToken().aud}&refresh_token=${refreshToken}`;
      this.http
        .post<{ access_token: string }>(`${url}`, body, { headers })
        .subscribe({
          next: (response) => {

            this.setToken(response.access_token);
          },
          error: () => {
            this.token = "";
            this.time = 0;
            this.storageService.clear()
            this.router.navigate([this.oidcLoginContext.getPendingConfigIdPath()]);
          }
        });
    });
  }

  removeToken(): void {
    this.token = "";
    this.time = 0;
    this.storageService.clear()
  }

  /**
   * Description: Checks if the JWT token is expired or close to expiration 
   * based on a defined warning time.
   * @date: 2025-11-14
   * @author: [Your Name Here]
   * @param {void}
   * @returns {boolean} Returns true if the token has expired (time left is <= 0) 
   * or if the remaining time is less than or equal to the warning time.
  */
  tokenExpired(): boolean {
    let defaultValue = 0
    const warningTime = .5 * 60 * 1000;
    const timeToExpire = (this.getInfoToken()?.exp ?? defaultValue) * 1000;
    const dateExpire = new Date(timeToExpire);
    const currentTime = new Date().getTime();
    const leftToExpire = dateExpire.getTime() - currentTime;
    return leftToExpire <= 0 || leftToExpire <= warningTime;
  }

  loadToken(): void {
    if (this.storageService.read(this.TOKEN_KEY)) {
      this.token = String(this.storageService.read(this.TOKEN_KEY));
    }
  }
}
